module.exports = __webpack_public_path__ + "mauritania.svg?4a520f68638b84f8a456fdd587908eca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mauritania.svg
// module id = 228
// module chunks = 10